module.exports = __webpack_public_path__ + "static/Calluna-It-webfont-534a29a149559ff529d897e95265ea13.woff2";